// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Highlights40FilledProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Highlights40Filled: FC<Highlights40FilledProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="40"
            height="40"
        >
            <path d="m35.5 30.778-4.611-4.611 1.944-1.945 4.612 4.611-1.945 1.945Zm-6-20-1.945-1.944 4.612-4.612 1.944 1.945-4.611 4.611Zm-19 0L5.889 6.167l1.944-1.945 4.612 4.612-1.945 1.944Zm-6 20-1.945-1.944 4.612-4.612 1.944 1.945L4.5 30.778ZM9.708 35l2.709-11.708-9.084-7.875 12-1.042L20 3.334l4.667 11.041 12 1.042-9.084 7.875L30.292 35 20 28.792 9.708 35Z" />
        </svg>
    );
};

export default Highlights40Filled;
